import { useEffect, useState } from 'react';
import { getMarketingStudioAccess } from '@/services/marketingStudioService';

/** The server owns LO enrollment; unresolved/revoked access stays out of navigation. */
export function useMarketingStudioNavigation(userKey: string, enabled: boolean, isDirector: boolean) {
  const [access, setAccess] = useState<{ key: string; allowed: boolean } | null>(null);
  useEffect(() => {
    setAccess(null);
    if (!enabled || isDirector) {
      return;
    }
    let disposed = false;
    let request = 0;
    const refresh = async () => {
      const current = ++request;
      try {
        const result = await getMarketingStudioAccess();
        if (!disposed && current === request) {
          setAccess({ key: userKey, allowed: result.enabled });
        }
      } catch {
        if (!disposed && current === request) {
          setAccess({ key: userKey, allowed: false });
        }
      }
    };
    void refresh();
    window.addEventListener('focus', refresh);
    return () => {
      disposed = true;
      window.removeEventListener('focus', refresh);
    };
  }, [userKey, enabled, isDirector]);
  return enabled && (isDirector || (access?.key === userKey && access.allowed));
}
